import store from "@/store";
import Travel from '@/components/game/scenes/Travel';
import TravelTracker from '@/components/game/sidebar/TravelTracker';

export default [
	{
		path: 'travel',
		name: 'TRAVEL',
		components: {
			gameSpace: Travel,
			sidebar: TravelTracker,
		},
		props: {
			sidebar: () => ({
				totalStops: store.getters["game/chapters/totalCount"],
				currentStop: store.state.game.chapters.index,
				traveling: true,
			}),
		},
		async beforeEnter(to, from, next) {
			await store.dispatch("sound/music/fade", { volume: 0, duration: 1000 });
			next();
		},
	},
	{
		path: 'travel/complete',
		async beforeEnter(to, from, next) {
			await store.dispatch("sound/music/fade", { volume: 1.0, duration: 1000 });
			next({ path: "/game/chapters/complete" });
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/travel.routes.js